var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLifeAndPeopleFood(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-2352.000000, -1241.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Life-and-people/Food",
    transform: "translate(2352.000000, 1241.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20,6 L20,14 C20,16.22 21.21,18.16 23,19.19 L23,32 C24.66,32 26,30.66 26,29 L26,0 C22.689,0 20,2.69 20,6 M15,1 L15,12.13 C15,13.99 13.73,15.56 12,16 L12,29 C12,30.66 10.66,32 9,32 L9,16 C7.27,15.56 6,13.99 6,12.13 L6,1 C6.55,1 7.05,1.22 7.41,1.59 C7.78,1.95 8,2.45 8,3 L8,10 L9.5,10 L9.5,2 C9.5,1.45 9.95,1 10.5,1 C11.05,1 11.5,1.45 11.5,2 L11.5,10 L13,10 L13,3 C13,1.9 13.9,1 15,1",
    id: 204
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLifeAndPeopleFood);
export default __webpack_public_path__ + "static/media/life-and-people-food.b9f90613.svg";
export { ForwardRef as ReactComponent };